export default {
    getDoctors(axios) {
        return axios({
            url: `doctors`,
            method: 'GET'
        })
    },
    get(id, axios) {
        return axios({
            url: `doctors/${id}/view`,
            method: 'GET'
        })
    },
    add(patientData, axios) {
        return axios({
            url: `doctors/add`,
            method: 'POST',
            data: patientData
        })
    },
    update(id, patientData, axios) {
        return axios({
            url: `doctors/${id}/update`,
            method: 'POST',
            data: patientData
        })
    },
    delete(id, axios) {
        return axios({
            url: `doctors/${id}/delete`,
            method: 'POST'
        })
    },
    fullExport(axios) {
        return axios({
            url: `doctors/exportContacts`,
            method: 'GET',
            responseType: 'blob'
        })
    }
}
